import { Component, OnInit } from '@angular/core';
import { DataService } from "../services/dataservice.service";

@Component({
  selector: 'app-sponsors',
  templateUrl: './sponsors.component.html',
  styleUrls: ['./sponsors.component.css']
})
export class SponsorsComponent implements OnInit {

  private intro: string = '';

  constructor(private dataService: DataService) {

    this.dataService.dataServiceArrived.subscribe(
      (data) =>
      {
        this.intro = data.filter((data) => {return data.Type == 'intro-sponsors'})[0].Content;
      }
    )
  }

  ngOnInit() {
    this.dataService.getContent()
  }

}



// WEBPACK FOOTER //
// ./src/app/main/sponsors/sponsors.component.ts